import ChartBase, { ChartType } from "./ChartBase";
import NoteEvent from "./events/NoteEvent";
export default class ChartBeatbox extends ChartBase {
    parse(data) {
        let len = data.length;
        let elm = null;
        // Normalize Beatbox
        for (let i = 0; i < len; i++) {
            elm = data[i];
            if (elm[2] === undefined) {
                elm[2] = 'blue';
            }
            if (elm[3] === undefined) {
                elm[3] = Math.round((elm[0] / 30) * 1000);
            }
        }
        // Beatbox to Events
        const ColorMapping = {
            'blue': 0,
            'red': 1,
            'purple': 2,
            'yellow': 3,
            'pink': 4,
            'orange': 5,
            'cyan': 6,
            'green': 7,
            'white': 8
        };
        const ColumnMapping = {
            'L': 0,
            'D': 1,
            'U': 2,
            'R': 3
        };
        let timeline = [];
        for (let i = 0; i < len; i++) {
            let [src_frame, src_column, src_color, src_time] = data[i];
            let note = new NoteEvent(i);
            note.COLUMN = ColumnMapping[src_column];
            note.COLOR = ColorMapping[src_color];
            note.TIME = src_time;
            timeline.push(note);
        }
        this.charts.push({
            columns: 4,
            difficulty: 0,
            name: 'Default',
            timeline: timeline
        });
        this.info = {
            title: "FFR BeatBox",
            music: "audio.mp3"
        };
        // Set Types
        this._validTypes = ChartType.CMOD;
        return true;
    }
}
